import styled from 'styled-components';

export const Container = styled.div``;

/**
 * The one page-level action, when the reservation is in the state that has
 * one. Everything else this screen does lives on the card's own action bar.
 */
export const Confirm = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: var(--s4);
`;
